export default {
  getquote: {
    title: "تسجيل المطعم",
    full_name: "الاسم الكامل",
    company_name: "اسم الشركة",
    select_country: "اختر الدولة",
    select_city: "اختر المدينة",
    restaurant: "المطعم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    next: "التالي",
  },
};